<template>
  <div id="product" class="bg-light">
    <div class="container p-5">
      <div class="container center pt-4 h4 text-primary lh-base">
        <p v-html="$t('allProduct.title3')"></p>
      </div>

      <div class="row justify-content-center gy-4">
        <div
          class="col-12 col-md-6 col-lg-6"
          v-for="(p, index) in productList"
          :key="p.name || index"
        >
          <!-- ★ 整張卡片可點：用 router-link 包住整張卡 -->
          <router-link
            :to="{ name: 'AppProduct', params: { id: p.name } }"
            class="product-card-link"
            :aria-label="$t(`${p.name}.name`)"
          >
            <div
              class="product-card shadow-sm p-3 mb-5 bg-white rounded"
              :style="cardStyles[index]"
              @mousemove="onCardMove($event, index)"
              @mouseleave="onCardLeave(index)"
            >
              <!-- 圖片：改成一般容器即可（整張卡片已是可點） -->
              <div class="img-link">
                <div class="ratio-box ratio-4-3">
                  <img class="fit" :src="p.src" :alt="$t(`${p.name}.name`)" loading="lazy" />
                </div>
              </div>

              <div class="product-description mt-3">
                <p class="product-title" v-if="p.usDesc" v-html="p.usDesc"></p>
                <p class="product-title" v-html="$t(`${p.name}.name`)"></p>
                <p class="product-desc" v-html="$t(`${p.name}.shortDesc`)"></p>

                <!-- VIEW ALL：保留視覺、但不再是第二個超連結以免巢狀 a -->
                <span class="mt-auto fw-bold text-decoration-none view-more text-primary" aria-hidden="true">
                  VIEW ALL <i class="fa-solid fa-angles-right"></i>
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import product from '@/config/product.js'

export default {
  name: 'ProductCards',
  data () {
    return {
      // 排除嵌入頁
      productList: product,
      // productList: product.filter( //*hide*
      //   p => !['TskSelectNeedle', 'TSKSyringe'].includes(p.name)
      // ),
      cardStyles: []
    }
  },
  mounted () {
    const base = {
      transform: 'perspective(600px) rotateY(0deg) rotateX(0deg) scale(1)',
      transition: 'transform 0.3s cubic-bezier(.25,.8,.25,1)'
    }
    this.cardStyles = this.productList.map(() => ({ ...base }))
  },
  methods: {
    onCardMove (e, idx) {
      const card = e.currentTarget
      const rect = card.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      const midX = rect.width / 2
      const midY = rect.height / 2
      const rotateY = ((x - midX) / midX) * 12
      const rotateX = ((midY - y) / midY) * 12

      const styles = this.cardStyles.slice()
      styles[idx] = {
        transform: `perspective(600px) rotateY(${rotateY}deg) rotateX(${rotateX}deg) scale(1.03)`,
        transition: 'transform 0.12s cubic-bezier(.25,.8,.25,1)'
      }
      this.cardStyles = styles
    },
    onCardLeave (idx) {
      const styles = this.cardStyles.slice()
      styles[idx] = {
        transform: 'perspective(600px) rotateY(0deg) rotateX(0deg) scale(1)',
        transition: 'transform 0.3s cubic-bezier(.25,.8,.25,1)'
      }
      this.cardStyles = styles
    }
  }
}
</script>

<style scoped>
/* 讓整張卡片的 router-link 像區塊一樣，並繼承原文字樣式 */
.product-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  outline: none;
}
.product-card-link:focus-visible .product-card {
  box-shadow: 0 0 0 3px rgba(80, 167, 223, .35);
}

.product-card {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  height: 100%;
  will-change: transform;
  cursor: pointer;
  transition: box-shadow 0.15s;
}
.product-card:hover { box-shadow: 0 10px 32px rgba(0,0,0,0.18); }

.product-description {
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.product-description p.product-title { 
  font-weight: bold; 
  color: #5fa4b8;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.product-description p.product-desc {
  margin: 10px 0 15px;
  font-size: 14px;
  color: #707070;
  line-height: 1.5;
}

/* 保留原比例盒 */
.ratio-box { position: relative; width: 100%; overflow: hidden; border-radius: 10px; }
.ratio-4-3 { padding-top: 75%; }
.fit { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }

/* 讓 VIEW ALL 看起來像連結，但實際上點整卡即可 */
.view-more { display: inline-flex; align-items: center; gap: 6px; }

@media (max-width: 576px) {
  .product-card { height: auto; }
  .product-description p { white-space: normal; text-overflow: clip; }
}
</style>
